"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasLoginErrorSelector = hasLoginErrorSelector;
exports.hasPasswordErrorSelector = hasPasswordErrorSelector;
exports.isFormSubmitting = isFormSubmitting;
exports.isLoginInvalidSelector = isLoginInvalidSelector;
exports.isPasswordInvalidSelector = isPasswordInvalidSelector;
exports.isProfessionalUserSelector = isProfessionalUserSelector;
exports.loginErrorSelector = loginErrorSelector;
exports.loginSelector = loginSelector;
exports.passwordErrorSelector = passwordErrorSelector;
exports.passwordSelector = passwordSelector;
var _authentication = require("../../../../types/authentication");
var _flow = require("../../../../types/flow");
var _registration = require("../../../../types/registration");
var _validation = require("../../../../utils/validation");
function isFormSubmitting(state) {
  const {
    activeFlow,
    authentication,
    registration
  } = state;
  if (activeFlow === _flow.EActiveFlow.Registration) {
    return registration.register.status === _registration.ERegisterStatus.Loading || registration.register.status === _registration.ERegisterStatus.Succeed;
  } else if (activeFlow === _flow.EActiveFlow.Authentication) {
    return authentication.authenticate.status === _authentication.EAuthenticateStatus.Loading || authentication.authenticate.status === _authentication.EAuthenticateStatus.Succeed;
  } else {
    return authentication.checkEmail.status === _authentication.ECheckEmailStatus.Loading;
  }
}
function loginSelector(state) {
  return state.login;
}
function hasLoginErrorSelector(state) {
  const {
    activeFlow,
    authentication,
    registration
  } = state;
  if (activeFlow === _flow.EActiveFlow.Registration) {
    return registration.register.error !== undefined && registration.register.errorType === _registration.ERegisterErrorType.Email;
  } else if (activeFlow === _flow.EActiveFlow.Authentication) {
    return authentication.authenticate.error !== undefined && authentication.authenticate.errorType === _authentication.EAuthenticateError.Common;
  } else {
    return authentication.checkEmail.error !== undefined;
  }
}
function isLoginInvalidSelector(state) {
  const {
    login
  } = state;
  return login === '' || login !== '' && !(0, _validation.isValidLogin)(login);
}
function loginErrorSelector(state) {
  if (!hasLoginErrorSelector(state)) {
    return undefined;
  }
  const {
    activeFlow,
    registration,
    authentication
  } = state;
  if (activeFlow === _flow.EActiveFlow.Registration) {
    return registration.register.error;
  } else if (activeFlow === _flow.EActiveFlow.Authentication) {
    return authentication.authenticate.error;
  } else {
    return authentication.checkEmail.error;
  }
}
function passwordSelector(state) {
  return state.authentication.password;
}
function hasPasswordErrorSelector(state) {
  return state.registration.register.error !== undefined && state.registration.register.errorType === _registration.ERegisterErrorType.Password;
}
function passwordErrorSelector(state) {
  return hasPasswordErrorSelector(state) ? state.registration.register.error : undefined;
}
function isPasswordInvalidSelector(state) {
  return state.authentication.password === '';
}
function isProfessionalUserSelector(state) {
  return state.registration.isProfessionalUser;
}